import _ from 'lodash';

function allFieldsAssignedToSections({ offers, preface }) {
    const allFields = _.flatMap(offers, o => o.sections[0].offers.flatMap(so => so.fields));
    if (!preface) return _.isEmpty(allFields);
    const allFieldsInPreface = allFields.filter(f => preface.includes(f.id));
    return _.isEmpty(allFieldsInPreface);
}

export { allFieldsAssignedToSections };